var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    fillRule: "evenodd",
    d: "M4 16C4 9.376 9.376 4 16 4s12 5.376 12 12-5.376 12-12 12S4 22.624 4 16zm12 9.6c-5.292 0-9.6-4.308-9.6-9.6s4.308-9.6 9.6-9.6 9.6 4.308 9.6 9.6-4.308 9.6-9.6 9.6zm.017-15.9c3.226.132 4.63 3.372 2.713 5.802-.256.307-.592.56-.912.802-.307.23-.6.452-.794.698-.404.498-.404 1.098-.404 1.698h-1.809c0-1.002 0-1.848.404-2.448.271-.408.732-.703 1.156-.974.2-.127.39-.25.55-.376 1.46-1.344 1.098-3.246-.904-3.402-.48 0-.94.19-1.279.527-.339.338-.53.796-.53 1.273H12.4c0-.955.381-1.87 1.06-2.546A3.624 3.624 0 0 1 16.017 9.7zm-1.206 10.8h1.809v1.8h-1.809v-1.8z",
    clipRule: "evenodd"
  })));
};
export default SvgHelp;